import { connect } from "react-redux";
import axios from "axios";
import { Modal } from 'antd';

function countDown() {
  Modal.success({
    title: 'Order Submitted ',
    content: `We Will be in contact with you soon.`,
  });
}


function mapStateToProps(state) {
    return { designer: state.designer }
}

const mapDispatchToProps = (dispatch) => {
    return {
      // dispatching plain actions
      onSelectedShirtTypeChange: (payload) => dispatch({ type: 'SELECTED_SHIRT_TYPE_CHANGED',payload }),
      onMenuKeyChange: (payload) => dispatch({ type: 'MENU_KEY_CHANGED',payload }),
      onSelectedColorChange: (payload) => dispatch({ type: 'SELECTED_COLOR_CHANGED',payload }),
      onSelectedImageTypeChange: (payload) => dispatch({ type: 'SELECTED_IMAGE_TYPE_CHANGED',payload }),
      onFlipImageClicked: (payload) => dispatch({ type: 'FLIP_IMAGE_CLICKED' }),
      setCanvas: (payload) => dispatch({ type: 'SET_CANVAS',payload }),
      setFrontCanvasJson: (payload) => dispatch({ type: 'SET_FRONT_CANVAS_JSON',payload }),
      setBackCanvasJson: (payload) => dispatch({ type: 'SET_BACK_CANVAS_JSON',payload }),
      handleFormSubmit:(payload)=>{
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*' 
        axios.post('https://dshirtak-back-test.herokuapp.com/api/orders',payload).then(()=>{dispatch({ type: 'CHANGE_LOADING_STATE' });countDown();document.getElementById('scanner').style.display='none';document.getElementById('Loader').style.display='none'}).catch(err=>{alert('Error please try again later');dispatch({ type: 'CHANGE_LOADING_STATE' });document.getElementById('scanner').style.display='none';document.getElementById('Loader').style.display='none';dispatch({ type: 'CHANGE_LOADING_STATE' })});
      },
      increasePrice:(payload)=>dispatch({ type: 'INCREASE_PRICE',payload }),
      decreasePrice:(payload)=>dispatch({ type: 'DECREASE_PRICE',payload }),
      changeLoadingState:(payload)=>dispatch({ type: 'CHANGE_LOADING_STATE' }),
      setAvailableColors:(payload)=>dispatch({type:'SET_AVAILABLE_COLORS',payload}),
      setPrice:(payload)=>dispatch({type:'SET_PRICE',payload}),
      setSize:(payload)=>dispatch({type:'SET_SIZE',payload})


      
    }
}

export default connect(mapStateToProps,mapDispatchToProps);
  
